/*
 * Copyright 2023 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import { Box, DialogTitle, IconButton, Typography } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import React, { FunctionComponent } from "react";
import { SourceInfoDrawerHeaderProps } from "./drawer-header-v1.interfaces";
import { useSourceInfoDrawerHeaderStyles } from "./drawer-header-v1.styles";

export const DrawerHeaderV1: FunctionComponent<SourceInfoDrawerHeaderProps> = ({
    title,
    handleClose,
}) => {
    const classes = useSourceInfoDrawerHeaderStyles();

    // Render UI
    return (
        <DialogTitle
            disableTypography
            classes={{
                root: classes.root,
            }}
        >
            <Box
                alignItems="center"
                component="div"
                display="flex"
                justifyContent="space-between"
            >
                <Typography variant="h6">{title}</Typography>
                <IconButton data-testid="close-drawer" onClick={handleClose}>
                    <Close />
                </IconButton>
            </Box>
        </DialogTitle>
    );
};
